import { Dialog, DialogContent, Divider, createStyles, makeStyles } from '@material-ui/core';
import { DialogTitle } from '../ModalCommon';
import React from 'react';
const useStyles = makeStyles((theme) => createStyles({
    root: {
        margin: 0,
        padding: theme.spacing(3, 7, 4),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& > *:nth-of-type(1)': {
            width: '100%',
        },
        overflowY: 'visible',
    },
    container: {
        overflowY: 'scroll',
    },
}));
const FormModal = ({ hideModal, title, children, maxWidth, ...rest }) => {
    const classes = useStyles();
    return (React.createElement(Dialog, Object.assign({ open: true }, rest, { maxWidth: maxWidth || 'xs', fullWidth: true, classes: { container: classes.container }, PaperProps: { classes: { root: classes.container } } }),
        React.createElement(DialogTitle, { onClose: hideModal }, title),
        React.createElement(Divider, null),
        React.createElement(DialogContent, { className: classes.root }, children)));
};
export default FormModal;
//# sourceMappingURL=FormModal.js.map